import * as React from 'react';

import { isFunction } from '@impuls-coach/util-is';
import noop from 'helper/noop';

import Icon from 'components/atoms/Icon';

export type SummaryElement = {
	icon: string;
	label?: string;
	value?: string;
	_target?: {
		id: string;
	};
};

export type SummaryProps = {
	title?: string;
	onEdit?: Function;
	modifier?: string;
	elements: SummaryElement[];
};

export default class Summary extends React.Component<SummaryProps> {
	public static displayName = 'Summary';
	public static defaultProps: Partial<SummaryProps> = {
		onEdit: noop,
	};

	public renderElement(element: SummaryElement, index: number) {
		const { icon, label, value, _target } = element;

		const editHandler = this.props.onEdit;
		const targetId = _target && _target.id ? _target.id : '';

		const clickWrapper = () => {
			if (editHandler && isFunction(editHandler)) {
				editHandler.apply(this, [targetId]);
			}
		};

		const classNames = ['m-summary__element'];
		if (_target) {
			classNames.push(`state-${classNames[0]}--editable`);
		}

		return (
			<li key={`summary-${index}`} className={classNames.join(' ')} onClick={clickWrapper}>
				<span className="m-summary__icon">
					<Icon iconName={icon} />
				</span>
				<div className="m-summary__content">
					<span className="m-summary__label">{label}</span>
					<span className="m-summary__value">{value}</span>
				</div>
				{_target && (
					<span className="m-summary__edit">
						<Icon iconName="pen" />
					</span>
				)}
			</li>
		);
	}

	public render() {
		const { title, elements, modifier } = this.props;

		return (
			<div className={`m-summary${modifier ? ` m-summary--${modifier}` : ''}`}>
				{title && <h4 className="m-summary__title">{title}</h4>}
				<ul className="m-summary__list">{elements.map(this.renderElement.bind(this))}</ul>
			</div>
		);
	}
}
